<template>
    <v-btn :disabled="!deveHabilitarBotoes" outline color="primary" @click.stop="$emit('baixarDocumentoEmLote')">
        <v-icon left size="15">fas fa-download</v-icon>
        Baixar
    </v-btn>
</template>

<script>
export default {
    name: 'BotaoBaixarDocumentoEmLote',
    props:['deveHabilitarBotoes']
}
</script>

<style scoped lang="stylus">

</style>